import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource='/catalog/job_group/'
const detailResource='/catalog/job_group_detail/'
const tableResource='/catalog/job_group_table/'
const runResource='/operations/run_job_group/'

export default {
    get(){

    },
    get(id){
        return Client.get(`${detailResource}?id=${id}`);
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    post(payload){
        return Client.post(resource,payload);
    },
    put(id,payload){
        return Client.put(`${resource}${id}/`,payload);
    },
    runJobGroup(id){
        return Client.post(runResource+id+'/');
    },
}